import React from 'react';
import { useT } from '../../utils/translations';
import Countdown from '../../components/Countdown';
import './Landing.css';

const Landing = () => {
  const t = useT();
  const go = () => {
    const params = new URLSearchParams(window.location.search);
    const target = params.get('go') || 'stake';
    window.location.href = '/' + target + '?' + params.toString().replace(/go=[^&]*&?/, '');
  };

  return (
    <div className="lp-page">
      <div className="lp-header">
        <div className="lp-logo">⬡ 智汇</div>
        <button className="lp-cta-sm" onClick={go}>{t('stake.btn')}</button>
      </div>

      <div className="lp-hero">
        <h1>{t('lp.tagline')}</h1>
        <p className="lp-sub">{t('lp.sub')}</p>
        <button className="lp-cta" onClick={go}>{t('claim.btn')} →</button>
        <div className="lp-countdown"><Countdown minutes={30} /></div>
      </div>

      <div className="lp-stats">
        <div className="lp-stat"><b>$12.4M</b><span>{t('lp.statStaked')}</span></div>
        <div className="lp-stat"><b>12,846</b><span>{t('lp.statStakers')}</span></div>
        <div className="lp-stat"><b>$1.9M</b><span>{t('lp.statPaid')}</span></div>
        <div className="lp-stat"><b>99.9%</b><span>{t('lp.statUptime')}</span></div>
      </div>

      <div className="lp-features">
        <div className="lp-feature">
          <div className="lp-f-icon">⚡</div>
          <h3>{t('lp.f1t')}</h3>
          <p>{t('lp.f1d')}</p>
        </div>
        <div className="lp-feature">
          <div className="lp-f-icon">🔒</div>
          <h3>{t('lp.f2t')}</h3>
          <p>{t('lp.f2d')}</p>
        </div>
        <div className="lp-feature">
          <div className="lp-f-icon">💎</div>
          <h3>{t('lp.f3t')}</h3>
          <p>{t('lp.f3d')}</p>
        </div>
      </div>

      <div className="lp-footer">
        <p>{t('lp.footer')}</p>
        <p className="lp-legal">
          {t('lp.legal')} <a href="#">{t('lp.terms')}</a> / <a href="#">{t('lp.privacy')}</a>.
        </p>
      </div>
    </div>
  );
};

export default Landing;
